import Chack from "../components/configuration/chack/Chack";

const ChackPage = () => {
  return <Chack />;
};

export default ChackPage;   
